<template>
  <div class="box">
    <div class="box__trg" @click="trg = !trg">
      <h4 :class="{'active': trg}">{{ name }}</h4>
      <svg :class="{'active': trg}" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-371.69 267.69-584 296-612.31l184 184 184-184L692.31-584 480-371.69Z"/></svg>
    </div>
    <div class="box__content" :class="{'active': trg}">
      <div class="box__content__inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .box{
    background: module.$gray;
    border-radius: .8rem;
    &__trg{
      padding: 1.6rem 2.4rem;
      font-size: 1.4rem;
      position: relative;
      cursor: pointer;
      h4{
        position: relative;
        transition: all 300ms module.$ease;
        &:before{
          content: '';
          position: absolute;
          top: 50%;
          left: 1rem;
          width: .64rem;
          height: .64rem;
          background: module.$base;
          opacity: 0;
          border-radius: 50%;
          transform: translateY(-50%);
          transition: all 300ms module.$ease;
        }
        &.active{
          padding: 0 0 0 1.44rem;
          color: module.$base;
          &:before{
            left: 0;
            opacity: 1;
          }
        }
      }
      svg{
        width: 2rem;
        position: absolute;
        top: 50%;
        right: 1.6rem;
        transform: translateY(-50%);
        transition: transform 300ms module.$ease;
        &.active{
          transform: translateY(-50%) rotateZ(180deg);
        }
      }
    }
    &__content{
      display: grid;
      grid-template-rows: 0;
      overflow: hidden;
      &.active{
        grid-template-rows: 1fr;
      }
      &__inner{
        margin: 1.6rem;
        margin-top: 0;
        padding: 1.6rem;
        border-radius: .4rem;
        background: module.$white;
      }
    }
  }
</style>

<script>
import { ref } from 'vue'
export default {
  props: {
    name: {
      type: String,
      required: true
    },
  },
  setup(props) {
    const trg = ref(false)
    return {
      trg,
      props
    }
  }
}
</script>
